import get from 'lodash/get'
import {
    FormattedBookingTypeData,
    BookingTypeStringsEnum,
} from '../../../../models/property-details-page/booking-type-model'

const is24HourBookingButtonVisible = ({ bookingType }: { bookingType: FormattedBookingTypeData | null }): boolean => {
    if (!bookingType) {
        return false
    }
    const type: string | null = get(bookingType, 'type')
    return type === BookingTypeStringsEnum.BINDING_INQUIRY
}

export default is24HourBookingButtonVisible
